const Whywaggexcommonchoice = ({ heading, description, paragraph }) => {
  return (
    <section className="w-full bg-[#FFFFFF] px-6 py-10">
      <div className="max-w-6xl mx-auto text-center mt-4 mb-4">
        <h2 className="text-[#10324F] text-xl sm:text-3xl font-roboto font-bold uppercase">
          {heading}
        </h2>

        <p className="mt-4 text-[#10324F] text-sm sm:text-base max-w-5xl mx-auto">
          {description}
        </p>
        {paragraph && (
          <p className="mt-4 text-[#10324F] text-sm sm:text-base max-w-5xl mx-auto">
            {paragraph}
          </p>
        )}
      </div>
    </section>
  );
};

export default Whywaggexcommonchoice;
